<template>
  <section class="person-center-intro">
    <el-form label-position="left" :label-width="language==='zh'?'100px':'120px'" :model="userInfo">
      <el-form-item :label="$t('global.简介')+'：'">
        <p class="intro" v-html="userInfo.enIntroduce.replace(/&nbsp;/g, ' ') || userInfo.introduce.replace(/&nbsp;/g, ' ')" v-if="language!=='zh'"></p>
        <p class="intro" v-html="userInfo.introduce.replace(/&nbsp;/g, ' ') || userInfo.enIntroduce.replace(/&nbsp;/g, ' ')" v-else></p>
      </el-form-item>
      <el-form-item :label="$t('global.创作领域')+'：'">
        <div class="field-list">
          <span v-for="item in userInfo.field" :key="item">{{item}}</span>
        </div>
      </el-form-item>
      <el-form-item :label="$t('global.联系方式')+'：'">
        <div class="link">
          <label v-if="userInfo.wechatLink && userInfo.wechatVisible">
            <span>{{$t('global.微信')}}</span>
            <b>{{userInfo.wechatLink}}</b>
          </label>
          <label v-if="userInfo.qqLink && userInfo.qqVisible">
            <span>QQ</span>
            <b>{{userInfo.qqLink}}</b>
          </label>
          <span
            v-if="(!userInfo.wechatLink ||! userInfo.wechatVisible) && (!userInfo.qqLink ||!userInfo.qqVisible)"
          >{{$t('global.暂无')}}</span>
        </div>
      </el-form-item>
      <el-form-item :label="$t('global.个人链接')+'：'">
        <div class="link-list">
          <label v-if="userInfo.homeLink">
            <img src="/static/v2/peopleCenter/social_icon_website_intro.png" alt />
            <a :href="userInfo.homeLink" target="_blank">{{userInfo.homeLink}}</a>
          </label>
          <label v-if="userInfo.weiboLink">
            <img src="/static/v2/peopleCenter/social_icon_weibo_intro.png" alt />
            <a :href="userInfo.weiboLink" target="_blank">{{userInfo.weiboLink}}</a>
          </label>
          <label v-if="userInfo.instagramLink">
            <img src="/static/v2/peopleCenter/social_icon_ins_intro.png" alt />
            <a :href="userInfo.instagramLink" target="_blank">{{userInfo.instagramLink}}</a>
          </label>
          <label v-if="userInfo.facebookLink">
            <img src="/static/v2/peopleCenter/social_icon_fb_intro.png" alt />
            <a :href="userInfo.facebookLink" target="_blank">{{userInfo.facebookLink}}</a>
          </label>
          <label v-if="userInfo.twitterLink">
            <img src="/static/v2/peopleCenter/social_icon_twitter_intro.png" alt />
            <a :href="userInfo.twitterLink" target="_blank">{{userInfo.twitterLink}}</a>
          </label>
        </div>
        <span
          v-if="!userInfo.twitterLink && !userInfo.homeLink && !userInfo.weiboLink && !userInfo.instagramLink && !userInfo.facebookLink"
        >{{$t('global.暂无')}}</span>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t("global.简介") + " | MANA"
    };
  },
  data() {
    return {
      userInfo: {}
    };
  },
  created() {
    this.init();
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    init() {
      this.userId = this.$route.params.userId;
      this.getUserInfo();
    },
    getUserInfo() {
      const url = `/api/mobile/u/getInfo`;
      const params = {
        userId: this.userId
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.userInfo = res.data;
          this.userInfo = {
            ...this.userInfo,
            field: (res.data.field && res.data.field.split(",")) || []
          };
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.person-center-intro {
  padding: 40px 0 100px;

  .intro {
    font-size: 14px;
    color: #333;
    white-space: pre-line;
    line-height: 24px;
    padding-top: 8px;
  }

  .field-list {
    span {
      background: #EBEBEB;
      color: #333;
      font-size: 14px;
      padding: 5px 8px;
      display: inline-block;
      line-height: 20px;
      margin-right: 10px;
    }
  }

  .link {
    font-size: 14px;

    label {
      padding-right: 30px;

      span {
        color: #999;
        margin-right: 10px;
      }

      b {
        color: #333;
      }
    }
  }

  .link-list {
    label {
      display: block;

      img {
        width: 30px;
        height: 30px;
        display: inline-block;
      }

      a {
        color: #333;
        font-size: 14px;
        font-family: NunitoSans-Regular, NunitoSans;
        font-weight: 400;

        &:hover {
          color: #0A0A0A;
        }
      }
    }
  }
}
</style>

<style lang="stylus">
.person-center-intro {
  .el-form {
    .el-form-item {
      label {
        color: #999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/peopleCenter/step/Introduce.vue